<template>
<div class="boxBreadcrumb my-0" v-if="filterBreadcrumbs.length > 0">
  <div class="boxBreadcrumb__row">
    <ul class="boxBreadcrumb__row--list mb-0" v-for="crumb in filterBreadcrumbs" :key="`breadcrumb_${crumb}`">
      <li >{{crumb}} <i class="fas fa-chevron-right"></i></li>
    </ul>
  </div>
</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'breadcrumb-vue',
  props: {
    breadcrumbs: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState('search', ['breadcrumbsForSelected']),
    hasBreadcrumbs() {
      return this.breadcrumbs.length > 0
    },
    hasStoreBreadcrumbs() {
      return this.breadcrumbsForSelected && this.breadcrumbsForSelected.length > 0
    },
    filterBreadcrumbs() {
      let breadcrumbsToShow = []
      if (this.hasBreadcrumbs) {
        breadcrumbsToShow = this.breadcrumbs
      } else if (this.hasStoreBreadcrumbs) {
        breadcrumbsToShow = this.breadcrumbsForSelected
      }
      return breadcrumbsToShow
    }
  }
}
</script>
